module.exports = {"520326001":"丹砂街道","520326002":"都濡街道","520326003":"大坪街道","520326101":"丰乐镇","520326102":"黄都镇","520326103":"涪洋镇","520326104":"镇南镇","520326105":"砚山镇","520326106":"浞水镇","520326107":"茅天镇","520326108":"柏村镇","520326110":"泥高镇","520326111":"分水镇","520326112":"蕉坝镇","520326203":"红丝乡","520326204":"石朝乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520326.json
// module id = 2470
// module chunks = 0